<template>
	<div class="ptrl-18-16 box-s" :class="{'pb-30': padShow }" id="nodes">
			<div v-for="(item, index) in list" :key="index">
				<div class="quest_header flexs mb-22" v-if="qusetNum == (index + 1)">
					<div class="c1 fz-16"> <span class="fz-28 fw-500">{{qusetNum}}</span> <span class="fw-500">/</span> <span class="c2">{{length}}</span> </div>

					<div v-if="item.question_type == 1" class="tag_class mt-12 ml-5 bg_ff c13">单选题</div>
					<div v-if="item.question_type == 2" class="tag_class mt-12 ml-5 bg_dc c12">多选题</div>
					<div v-if="item.question_type == 3" class="tag_class mt-12 ml-5 bg_ea c11">判断题</div>
				</div>
				<div class="fz-14 fw-500 c1 mb-22" v-if="qusetNum == (index + 1) && item.question_stem" v-html="item.question_stem"></div>
				<!-- 单选题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 1)">
					<li class="flexs bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'checked': item.right_answer[0] == Object.keys(innerItem)[0],'error_checked': item.student_answer[0] == Object.keys(innerItem)[0] && item.right_answer[0] !=item.student_answer[0], 'tag_lou': item.student_answer.length == 0 && item.right_answer == Object.keys(innerItem)[0] }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex">
						<div class="flexs flex1">
              <div class="">{{Object.keys(innerItem)[0]}}.</div>
						  <div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
            </div>
            <div>
						
						<img v-if="item.student_answer[0] == Object.keys(innerItem)[0] && item.right_answer[0] !=item.student_answer[0]" class="wh_14 ml-10" src="../../assets/img/icon/error_checked.png" alt="">
						<div v-else-if="item.student_answer.length == 0 && item.right_answer == Object.keys(innerItem)[0]" class="ml-10 wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
						<img v-else-if="item.right_answer[0] == Object.keys(innerItem)[0]" class="wh_16_11 ml-10" src="../../assets/img/icon/checked.png" alt="">
            </div>
					</li>
				</ul>

				<!-- 判断题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && (item.question_type == 3)">
					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'checked': item.right_answer == 'true', 'error_checked': item.student_answer == 'true' && item.right_answer == 'false', 'tag_lou': item.student_answer === '' && item.right_answer == 'true' }">
						<div class="flexs flex1">
              <div class="">A.</div>
						  <div class="ml-6" >正确</div>
            </div>
            
						<img v-if="item.student_answer == 'true' && item.right_answer == 'false'" class="wh_14 ml-10" src="../../assets/img/icon/error_checked.png" alt="">
						<div v-else-if="item.student_answer === '' && item.right_answer == 'true'" class="ml-10 wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
						<img v-else-if="item.right_answer == 'true'" class="wh_16_11 ml-10" src="../../assets/img/icon/checked.png" alt="">
					</li>

					<li class="flex bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'checked': item.right_answer == 'false', 'error_checked': item.student_answer == 'false' && item.right_answer == 'true', 'tag_lou': item.student_answer === '' && item.right_answer == 'false' }">
						
						<div class="flexs flex1">
              <div class="">B.</div>
					  	<div class="ml-6" >错误</div>
            </div>
            
						<img v-if="item.student_answer == 'false' && item.right_answer == 'true'" class="wh_14 ml-10" src="../../assets/img/icon/error_checked.png" alt="">
						<div v-else-if="item.student_answer === '' && item.right_answer == 'false'" class="ml-10 wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
						<img v-else-if="item.right_answer == 'false'" class="wh_16_11 ml-10" src="../../assets/img/icon/checked.png" alt="">
					</li>
				</ul>
				

				<!-- 多选题 -->
				<ul class="fz-14 c1" v-if="qusetNum == (index + 1) && item.question_type == 2">
					<li class="flexs bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{ 'checked': item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1, 'error_checked': item.student_answer.indexOf(Object.keys(innerItem)[0]) != -1 && (item.right_answer.indexOf(Object.keys(innerItem)[0]) == -1), 'tag_lou': item.student_answer.indexOf(Object.keys(innerItem)[0]) == -1 && (item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1) }" v-for="(innerItem, innerIndex) in item.prepare_option" :key="innerIndex"  >	
						<div class="flexs flex1">
              <div class="">{{Object.keys(innerItem)[0]}}.</div>
						  <div class="ml-6" v-html="innerItem[Object.keys(innerItem)[0]]"></div>
            </div>
            <img v-if="item.student_answer.indexOf(Object.keys(innerItem)[0]) != -1 && (item.right_answer.indexOf(Object.keys(innerItem)[0]) == -1)" class="ml-10 wh_14 " src="../../assets/img/icon/error_checked.png" alt="">
						<div v-else-if="item.student_answer.indexOf(Object.keys(innerItem)[0]) == -1 && (item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1)" class="ml-10 wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
						<img v-else-if="item.right_answer.indexOf(Object.keys(innerItem)[0]) != -1" class="ml-10 wh_16_11" src="../../assets/img/icon/checked.png" alt="">
					</li>
				</ul>


				<!-- 答案 -->
				<div class="animal pt-22" v-if="qusetNum == (index + 1)">
					<div class="mb-22">
						<div class="flexs flex-jus fw-500 c1">
							<div class="flexs">
								<img class="wh_32 mr-10" src="../../assets/img/icon/answer_icon.png" alt="">
								<div class="l-h-16 fz-16  ">题目解析～巩固你的知识吧！</div>
							</div>
							<div class="flexs fz-10 bg_f9 flex-center b-radius-10 wh_74_20" @click="jumpReaction">
								纠错反馈
								<img class="wh_4_6 ml-8" src="../../assets/img/icon/gray_right_arrow_icon.png" alt="">
							</div>
						</div>
					</div>

					<div class="flexs flex-wrap fz-14 fw-500 c1 mb-22">
						<div class="mr-30 flexs">
							<div class="w75 wrp">正确答案：</div>
							<div class="c0 ">
								{{Array.isArray(item.right_answer)? item.right_answer.join(''): (item.right_answer == 'true'? '正确': item.right_answer == 'false'? '错误': item.right_answer)}}
							</div> 
						</div>

						<div class="flexs">
							<div class="w75 wrp">你的答案：</div>
							<div class="c0" :class="{ 'c9': item.is_result != 1 }">
								{{Array.isArray(item.student_answer)?(item.student_answer.join('')?item.student_answer.join(''):'未答'):(item.student_answer ==='true'? '正确': item.student_answer === 'false'? '错误': item.student_answer === ''? '未答': item.student_answer) }}
							</div> 
						</div>
					</div>


					<div class="fz-14  c1">
						<div class="fw-500 mb-8">题目解析：</div>
						<div v-if="item.analysis" v-html="item.analysis"></div>
					</div>
				</div>
			</div>
		<loading :loadFlag="loadFlag"></loading>
    <qusetBottom :length="length" :questBtn="questBtn" :cData="cData" :collectFalg="collectFalg" :qusetNum="qusetNum" @getQuest="getQuest" @collect="collect" @quertCard="quertCard" ></qusetBottom>
	</div>
</template>
<script>
  
	import { gateLevelComeOut  } from '@/api/api'
	import {getShowPadding} from "@/utils/common.js";
	import loading from "@/components/loading"
	import qusetBottom from "@/components/qusetBottom.vue";
	export default {
		components: {
      qusetBottom,
			loading
		},
		data() {
			return {
				length: 0,//题目数量
				padShow: false, //是否展示底部30padding
				list: [], //每一页的题数据
				qusetNum: 1, //第几道题
        number: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U","V", "W", "X", "Y", "Z"],
				collectFalg: false, //是否收藏
				cData:{
					question_id: '',
					model_type: 4,
					way: 3,
					base_user_id: ''
				},
				answerdata:'',
				loadFlag: false,
				questBtn: false
			};
		},
		created() {
			console.log(999)
			this.cData.base_user_id = this.$route.query.gate_level_user_id
			this.qusetNum = this.$route.query.qusetNum? Number(this.$route.query.qusetNum):1
			this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},
		watch: {
			qusetNum: {
				handler(newvalue, oldvalue){
					
				}
			}
		},
		methods: {
			async initData(){
				this.loadFlag = true
        const res = await gateLevelComeOut({ gate_level_user_id: this.$route.query.gate_level_user_id })
				this.loadFlag = false
				if(res.code == 1000){
          this.list = res.data
					this.cData.question_id = this.list[this.qusetNum - 1].question_id
					let arr = this.list.map(item=> item.is_result)
					this.answerdata = arr.length == 0?'':(arr.length == 1? arr[0]:arr.join(','))
					this.length = this.list.length
					this.collectFalg = this.list[this.qusetNum - 1].question_wrong_id == 0? false : true
				} else {
					this.$toast(res.msg)
				}
			},

			// 上一页，下一页
			getQuest(type){
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				if(type == '1'){
          this.qusetNum -= 1
				} else if (type == '2') {
          this.qusetNum += 1
				}
				this.collectFalg = this.list[this.qusetNum - 1].question_wrong_id == 0? false : true
				this.cData.question_id = this.list[this.qusetNum - 1].question_id
			},

			// 收藏
			collect(collectFalg){
        this.collectFalg = !collectFalg
				this.list[this.qusetNum - 1].question_wrong_id = this.collectFalg? 1: 0
			},
			// 查看答题卡
			quertCard(type){
				if(type != 1){
          this.$router.replace({ path: '/passanalysiscard', query: { gate_level_user_id: this.$route.query.gate_level_user_id, answerdata: this.answerdata, qusetNum: this.qusetNum } })
				}
        
			},
      
			// 错题反馈
			jumpReaction(){
        this.$router.replace({ path: '/reaction', query: { question_id: this.list[this.qusetNum - 1].question_id, qusetNum: this.qusetNum, gate_level_user_id: this.$route.query.gate_level_user_id,type: 'pass' } })
			}

		}
	};
</script>
<style lang="less" scoped>
ul li:last-child {
	margin-bottom: 0;
}
</style>
